import ApiClient from "@/api/clients/ApiClient";
import Locales from "@/utils/locales";
import { i18n } from "vue-lang-router";
import { AxiosRequestConfig } from "axios";

export default class MosaiqClient extends ApiClient {

  constructor() {
    const MOSAIQ_PORT = process.env.VUE_APP_MOSAIQ_PORT ? ":" + process.env.VUE_APP_MOSAIQ_PORT : "";
    super({
      baseURL: process.env.VUE_APP_MOSAIQ_HTTP_VERSION + "://" + process.env.VUE_APP_MOSAIQ_HOST + MOSAIQ_PORT + process.env.VUE_APP_MOSAIQ_API_ROUTE,
      headers: {
        Accept: "application/json",
        common: {
          "X-MOSAIQ-API-KEY": process.env.VUE_APP_MOSAIQ_API_KEY,
        },
      }
    });

    this._axiosInstance.interceptors.request.use((config: AxiosRequestConfig) => {
      config.params = config.params || {};
      config.params.locale = encodeURIComponent(Locales.getLocaleCode(i18n.locale));

      return config;
    });
  }

  static of(): MosaiqClient {
    return new MosaiqClient();
  }
}
